module.exports = __webpack_public_path__ + "img/55.6f01a880.png";